import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import CreateAlert from "./CreateAlert";

/**
 * The CreateAlertPage component renders the CreateAlert component
 * with a redirect back to the previous page when the alert is submitted.
 *
 * @returns {React.Component} The CreateAlertPage component.
 */
export default function CreateAlertPage() {
  const history = useHistory();
  const redirect = () => {
    history.goBack();
  };
  return (
    <div>
      <CreateAlert
        withSubmit={() => {
          redirect();
        }}
      />
    </div>
  );
}
